import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoFile = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>File</title>
    <path
      d="M25.857 12.75v14.525a2.429 2.429 0 0 1-2.429 2.429H8.571a2.429 2.429 0 0 1-2.43-2.429V6.703a2.429 2.429 0 0 1 2.43-2.429h8.475c.621 0 1.219.239 1.67.666l6.382 6.046c.485.459.759 1.097.759 1.763Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <path d="M11.714 18.703h8.57M11.714 23.275h8.57" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <path
      d="M25.714 12.417h-4.571a3.429 3.429 0 0 1-3.429-3.428V4.417"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoFile;
